import React, { forwardRef, useMemo } from 'react';
import styled from '@emotion/styled';
import { getThemeColor } from 'store/settings';
import { useSelector } from 'react-redux';
import { CustomInput } from 'reactstrap';

/**
 * @typedef {object} CustomCheckBoxProps
 * @property {string} [pureCss]
 */

/**
 * @type { React.ForwardRefExoticComponent< CustomCheckBoxProps & import('reactstrap').CustomInputProps & React.RefAttributes<import('reactstrap').CustomInputProps>>}
 */
const CheckBoxButton = forwardRef(({ pureCss, ...props }, ref) => {
  const themeStatus = useSelector(getThemeColor);

  const CheckBox = useMemo(
    () => styled(CustomInput)`
      .custom-control-input:focus ~ .custom-control-label::before {
        border-color: ${themeStatus};
        box-shadow: 0 2px 4px 0 ${themeStatus} !important;
      }
      .custom-control-input:checked ~ .custom-control-label::before {
        border-color: ${themeStatus};
        background-color: ${themeStatus};
      }
      .custom-control-input:not(:disabled) {
        &:active ~ .custom-control-label {
          &::before {
            background-color: ${themeStatus}!important;
            border-color: ${themeStatus}!important;
          }
        }
      }
      .custom-control-input[disabled] {
        &:checked ~ .custom-control-label {
          &::before {
            background-color: ${themeStatus}!important;
            border-color: ${themeStatus}!important;
            opacity: 50%;
          }
        }
      }
      .custom-checkbox .custom-control-label::after {
        border-radius: 0.25rem;
      }
      .custom-checkbox
        .custom-control-input:checked
        ~ .custom-control-label::after {
        background-color: ${themeStatus} !important;
        border-color: ${themeStatus}!important;
      }

      ${pureCss}
    `,
    [pureCss, themeStatus],
  );

  return <CheckBox innerRef={ref} {...props} />;
});

export default CheckBoxButton;
